export default __webpack_public_path__ + "Part 2 Context for Learning Questions.docx";